/* eslint-disable max-len */
import { SummaryCardHtmlId } from '../enums/elementId';
import { UserInfo } from '../container/App/interface';
import { getCMSConfig } from './cms';
import { toggleElementVisibilityById } from '@vfde-brix/ws10/core';

// FIXME: Unnecessary function chaining
// Handle unLogged user link
export const updateUnLoggedText = (userInfo?: UserInfo) => {
    toggleElementVisibilityById(SummaryCardHtmlId.LOGGED_STATE, !userInfo?.isLogged);
};

export const redirectToCable = (userInfo?: UserInfo) => {
    const cableTariffChangeLink = getCMSConfig()?.loggedCases?.cable?.url;

    if (cableTariffChangeLink && userInfo?.isLogged && !userInfo.isFixed && (userInfo.isUM || userInfo.isVKD)){
        location.assign(cableTariffChangeLink);
    }
};
